var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"define-table-wrap"},[_c('c-table',{staticClass:"defineTable",class:[
      _vm.config.props.isSpaced?'isSpaced':''
    ],attrs:{"data":_vm.tableData,"props":_vm.config.props,"header":_vm.tableColumn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }